import styles from "./dashboard.module.css";

import { ModuleProps } from "components/props/ModuleProps"
import { IconPicker } from "components/layout/icons/IconPicker";
import parse from 'html-react-parser';
import { ResponsiveContent } from "components/layout/ResponsiveContent";
import { DashboardItemOnline } from "./DashboardItemOnline";

interface DashboardDefaultItemProps {
    module: ModuleProps;
    onClick: (module: ModuleProps) => void;
}
export const DashboardDefaultItem = (props:DashboardDefaultItemProps) => {

    return (
        <DashboardItemOnline module={props.module}>
            <div className={styles.bar} onClick={() => props.onClick(props.module)}>
                <div className={styles.barContent}>
                    <div role="heading" className={styles.barContentHeader}>{parse(props.module.text)}</div>
                    <div className={styles.barContentIcon}><IconPicker icon={props.module.icon} size={24} /></div>
                </div>
                {
                    (props.module.minWidth) &&
                    <ResponsiveContent minWidth={props.module.minWidth}>Krever en bredde p&aring; mer enn 768px.</ResponsiveContent>
                }
            </div>
        </DashboardItemOnline>
    )
}

export default DashboardDefaultItem;
